import { Language } from "reducers/uiSlice";

/** Returns the language encoded in a pathname. */
export const getLanguageFromPath = (pathname: string): Language => {
  if (pathname === "/es" || pathname.startsWith("/es/")) return "es";
  if (pathname === "/zh-CN" || pathname.startsWith("/zh-CN/")) return "zh-CN";
  return "en";
};

/** Strips the language prefix from a pathname, returning the base English path. */
export const stripLangPrefix = (pathname: string): string => {
  if (pathname === "/es") return "/";
  if (pathname.startsWith("/es/")) return pathname.slice(3);
  if (pathname === "/zh-CN") return "/";
  if (pathname.startsWith("/zh-CN/")) return pathname.slice(6);
  return pathname;
};

/** Converts a base English pathname to the localised version. */
export const localizePath = (pathname: string, language: Language): string => {
  const base = stripLangPrefix(pathname);
  if (language === "es") return base === "/" ? "/es" : `/es${base}`;
  if (language === "zh-CN") return base === "/" ? "/zh-CN" : `/zh-CN${base}`;
  return base;
};
